<template>
	<BContainer>
		<BRow>
			<BCol cols="12" lg="7">
				<div class="page-skeleton">
					<div
						v-for="(section, index) in count"
						:key="index"
						class="page-skeleton__section"
						aria-label="Loading"
						aria-busy="true"
						aria-live="polite"
					>
						<div
							aria-hidden="true"
							role="presentation"
							class="page-skeleton__item --half"
						></div>
						<div
							aria-hidden="true"
							role="presentation"
							class="page-skeleton__item"
						></div>
						<div
							aria-hidden="true"
							role="presentation"
							class="page-skeleton__item"
						></div>
						<div
							aria-hidden="true"
							role="presentation"
							class="page-skeleton__item"
						></div>
					</div>
				</div>
			</BCol>

			<BCol cols="12" lg="4" offset-lg="1">
				<div class="page-skeleton">
					<div
						class="page-skeleton__section"
						aria-label="Loading"
						aria-busy="true"
						aria-live="polite"
					>
						<div
							aria-hidden="true"
							role="presentation"
							class="page-skeleton__item --half"
						></div>
						<div
							aria-hidden="true"
							role="presentation"
							class="page-skeleton__item"
						></div>
						<div
							aria-hidden="true"
							role="presentation"
							class="page-skeleton__item"
						></div>
						<div
							aria-hidden="true"
							role="presentation"
							class="page-skeleton__item"
						></div>
					</div>
				</div>
			</BCol>
		</BRow>
	</BContainer>
</template>

<script>
export default {
	props: {
		count: {
			type: Number,
			default: 3,
		},
	},
};
</script>

<style lang="scss" scoped>
.page-skeleton {
	display: flex;
	flex-direction: column;
	gap: var(--size-xl);
	padding: var(--size-lg) 0;

	&__section {
		display: grid;
		gap: var(--size-base);
	}

	&__item {
		height: var(--custom-control-height);
		border-radius: var(--size-sm);
		background: var(--gray-200);
		grid-column: span 2;
		position: relative;
		overflow: hidden;

		&.--half {
			grid-column: span 1;
		}

		&::after {
			will-change: transform;
			position: absolute;
			content: '';
			animation: shimmer 2s infinite;
			inset: 0;
			width: 100%;
			background: linear-gradient(
				to right,
				var(--gray-200) 4%,
				var(--gray-300) 25%,
				var(--gray-200) 36%
			);
		}
	}
}
</style>
